module.exports = __webpack_public_path__ + "static/media/ivan.2c35a8f0.jpg";